

import React from 'react';
import styled from 'styled-components';

import Mustache from 'mustache';

import { useDataContext } from '../../contexts/DataAdapterContext';










const ButtonBase = styled.button.attrs(
  (props) => ({
    style: {
      ...props.style,
      borderWidth: '1px'
    }
  }))`${(props) => props.computedStyle}`;

const ButtonWrapper = styled.div.attrs(
  (props) => ({
    style: { ...props.style }
  }))`${(props) => props.computedStyle}`;

const ButtonContent = styled.div.attrs(
  (props) => ({
    style: { ...props.style }
  }))`${(props) => props.computedStyle}`;

const replacedLink = ({ replaceVariables, buttonLink }) => {
  if (!replaceVariables) {
    return buttonLink;
  }

  try {
    const mustacheTemplate = buttonLink.replace(/\$\{(\w+)\}/g, '{{$1}}');
    return Mustache.render(mustacheTemplate, replaceVariables);
  } catch (e) {
    console.error(e);
    return buttonLink;
  }
};

const ButtonGroup = (props) => {
  const { buttons, container } = props;
  const { style: containerStyle, computedStyle: containerComputedStyle } = container;
  const { onButtonClick, isPreview, replaceVariables, allowCalendarLinks } = useDataContext();

  return (
    <ButtonWrapper style={containerStyle} computedStyle={containerComputedStyle}>
      {buttons.map((button) => {
        // allowCalendarLinks is set per elevate template and is the default visibility
        if (!isPreview && button.isCalendarLink && !allowCalendarLinks) {
          return null;
        }

        // isVisible or buttonLink is set on the splash template level
        if (!button.isVisible || !button.buttonLink) {
          return null;
        }

        if (isPreview && !replacedLink({ replaceVariables, buttonLink: button.buttonLink })) {
          return null;
        }

        return (
          <ButtonBase
            key={button.uuid}
            className="button"
            style={button.style}
            computedStyle={button.computedStyle}
            onClick={() => onButtonClick(button)}>

            <ButtonContent
              className="button__content"
              style={button.buttonTextStyles}>

              {button.buttonText}
            </ButtonContent>
          </ButtonBase>);

      })}
    </ButtonWrapper>);

};

export default ButtonGroup;